import {
    Box,
    Button,
    TextField,
    Typography,
    Chip,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    Tooltip,
    Pagination,
    CircularProgress,
    Backdrop,
    IconButton,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
// import { getSocket } from "../../socket";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import {
    DeleteOutline,
    DeleteSharp,
    ImportContacts,
} from "@mui/icons-material";
import GroupCreate from "./GroupCreate";
import useNotification from "../common/Notification";
import EditGroup from "./EditGroup";
import WarningMessage from "../common/WarningMessage";
import DeleteGroup from "./DeleteGroup";

import base_url from "../../constants";
import { blue } from "@mui/material/colors";
// const groupTabs = ["Create"];

const optionsArr = ["Personal", "Work", "Family"];

const GroupAdd = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [totalRows, setTotalRows] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [groupName, setGroupName] = useState("");
    const [fetchedGData, setFetchedGData] = useState([]);
    const [options, setOptions] = useState([]);
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [phoneValue, setPhoneValue] = useState("");
    const [searchedGName, setSearchGName] = useState("");
    const [filteredData, setFiltereData] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [userId, setUserId] = useState(Cookies.get("userId"));
    const [open, setOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(null);
    const [totalPage, setTotalPage] = useState(null);
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteModalOpening, setDeletModalOpening] = useState(false);
    // const socket = getSocket(userId);

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const showNotification = useNotification();

    const handleCheckboxChange = (idx) => {
        setSelectedRows((prevSelected) => {
            const exists = prevSelected.includes(idx);
            if (exists) {
                return prevSelected.filter((i) => i !== idx);
            } else {
                return [...prevSelected, idx];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            let temp = [];
            for (let i = 0; i < filteredData.length; i++) {
                temp.push(i);
            }
            setSelectedRows(temp);
        }
        setSelectAll(!selectAll);
    };

    console.log("Selected Rows: ", selectedRows);

    // To change the button look after switching

    // useEffect(() => {
    //     socket.on("response", ({ userId: currentUserId, message: message }) => {
    //         console.log(
    //             "Message after importing contacts:",
    //             message,
    //             currentUserId
    //         );
    //     });

    //     socket.on("contacts-sent", ({ userId: currentUserId, data }) => {
    //         console.log(data);
    //         alert("contacts Received");
    //     });
    //     return () => {
    //         socket.off("contacts-sent");
    //     };
    // }, []);

    const handleGroupAdd = async () => {
        const userId = Cookies.get("userId");

        // const data = contacts.map((contact) => {
        //     return {
        //         user_id: userId,
        //         phone_number: contact.toString(),
        //         group_name: groupName,
        //     };
        // });

        const data = selectedRows.map((row) => {
            return {
                user_id: userId,
                phone_number: filteredData[row].phone_number,
                group_name: groupName,
            };
        });

        console.log("Group data: ", data);
        try {
            const res = await axios.post(`${base_url}/create`, data);
            console.log(res);
            alert("Group Created");
        } catch (e) {
            alert("Failed to create group");
            console.error("Error: ", e);
        }
    };

    // To switch between create and view groups
    const handleTabChange = (i) => {
        setActiveTab(i);
    };

    // To delete the phone contacts
    const handleDelete = (idx) => {
        setContacts((prev) => {
            return prev.filter((_, i) => i !== idx);
        });
    };

    // To change the group name
    const handleChange = (field, e) => {
        if (field === "group") {
            setGroupName(e.target.value);
        }
        if (field === "phone") {
            setPhoneValue(e.target.value);
        }
    };

    // To add phone number
    const handleAddNumber = () => {
        console.log(phoneValue);
        if (!phoneValue) {
            alert("Please enter a phone number");
            return;
        }

        let formattedNumber = phoneValue.replace(/\D/g, "");
        // if (!formattedNumber.startsWith("91")) {
        //     formattedNumber = `91${formattedNumber}`;
        // }

        // const phonePattern = /^91[0-9]{10}$/;
        // const phonePattern = /^[0-9]{10}$/;
        const phonePattern = /^[0-9]{12}$/;

        if (!phonePattern.test(formattedNumber)) {
            alert(
                "Invalid phone number. Please enter a valid 10-digit number with Country code."
            );
            return;
        }
        console.log("formatted number: ", formattedNumber);

        // setPhoneValue((prev) => [...prev, formattedNumber]);
        setContacts((prev) => [...prev, formattedNumber]);
        setPhoneValue("");
    };

    // Fetching imported contacts

    const fetchImportedContacts = async () => {
        try {
            const phoneNumber = JSON.parse(localStorage.getItem("userPhone"));
            console.log(phoneNumber);
            if (!phoneNumber) {
                alert("No phone number , something went wrong");
                return;
            }

            const payload = {
                user_id: userId,
                user_phone_number: phoneNumber,
            };
            console.log(payload);

            const res = await axios.get(
                `http://api.virtualprachar.com/api/import/contact/getall/${userId}`
            );

            if (res.status == 200) {
                console.log(res.data.data);
                const data = res.data.data.map((obj) => {
                    return {
                        name: obj.name,
                        phone_number: obj.contacts,
                        group_name: "",
                    };
                });
                setFiltereData(data);
            }
        } catch (e) {
            console.log("Error: ", e);
        }
    };

    // Fetching Options for Groups
    const fetchingOptions = async () => {
        try {
            const res = await axios.get(`${base_url}/whatsapp/personal/group/get/${userId}`);
            console.log(res.data.data);
            let data = new Set();
            for (let obj of res.data.data) {
                data.add(obj.group_name);
            }
            let newData = [];
            data.forEach((e) => {
                newData.push(e);
            });
            // setOptions(res.data.data);
            // setSearchGName("");
            setOptions(newData);
        } catch (e) {
            console.error("Error: ", e);
            showNotification(
                "Something went wront please refresh the page",
                "error"
            );
        }
    };

    /********************************************************************************* */
    //         view group functions and apis
    /********************************************************************************** */

    useEffect(() => {
        fetchingOptions();

        // fetchImportedContacts();
    }, [open]);

    // Fetching group data

    const fetchGroupData = async (groupName, page) => {
        if (!page) page = 1;
        if (!searchedGName) {
            alert("Please enter group name!");

            return;
        }
        try {
            setBackdropOpen(true);
            showNotification("This might take few seconds!", "info");
            let tempGroup = encodeURIComponent(searchedGName);

            // setSearchGName("");
            const res = await axios.get(
                `${base_url}/whatsapp/personal/group/get?user_id=${userId}&group_name=${tempGroup}&page=${page}`
            );
            setFiltereData(res.data.data.data);
            setTotalRows(res.data.data.total);
            setTotalPage(res.data.data.last_page);
        } catch (e) {
            console.error("Error: ", e);
            showNotification("Something went wrong please try again!", "error");
        } finally {
            setBackdropOpen(false);
        }
    };

    const handleSelectionChange = (e) => {
        setSearchGName(e.target.value);
    };

    const handleRefresh = () => {
        fetchImportedContacts();
        fetchingOptions();
    };

    // const handleImport = () => {
    //     const userId = Cookies.get("userId");
    //     socket.emit("import-contacts", userId);

    //     alert("Contact Imported Refreshing Table");
    //     setTimeout(() => handleRefresh(), 5000);
    // };

    // Page change function
    const handlePageChange = (event, value) => {
        const page = value;
        setCurrentPage(value);

        fetchGroupData(searchedGName, page);
    };

    const resetData = () => {
        setFiltereData([]);
        setSearchGName("");
    };

    return (
        <Box sx={{ marginTop: "2rem" }}>
            <Backdrop
                sx={(theme) => ({
                    color: "#fff",
                    zIndex: theme.zIndex.drawer + 1,
                })}
                open={backdropOpen}
                // onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
                <Typography variant='h6'  sx={{ mb: 4, mt: 3, color : 'primary.main', backgroundColor:blue[50], px:2, width: 'fit-content', py:1, borderRadius:2, fontWeight:'bold'}}>
                    Manage Whatsapp Groups
                </Typography>


            {activeTab === 1 && (
                <Box
                    sx={{
                        height: "auto",
                        width: "100%",
                        marginTop: 2,
                    }}
                >
                    {open && (
                        <GroupCreate
                            opening={setOpen}
                            closing={setOpen}
                            open={open}
                        />
                    )}
                    {editOpen && (
                        <EditGroup
                            opening={setEditOpen}
                            closing={setEditOpen}
                            open={editOpen}
                        />
                    )}
                    {deleteModalOpening && (
                        <DeleteGroup
                            opening={setDeletModalOpening}
                            closing={setDeletModalOpening}
                            open={deleteModalOpening}
                        />
                    )}

                    <Box sx={{ width: "100%", display: "flex", gap: 1, mb: 2 }}>
                        <FormControl sx={{ width: "12rem" }}>
                            <InputLabel size="small">Select a group</InputLabel>
                            <Select
                                value={searchedGName}
                                label={"Select a group"}
                                onChange={handleSelectionChange}
                                size="small"
                            >
                                {options.map((option, i) => (
                                    <MenuItem key={i} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={fetchGroupData}
                        >
                            Search
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={resetData}
                        >
                            Reset
                        </Button>

                        <Box sx={{ marginLeft: "auto" }}>
                            {/* <TextField
                                disabled={
                                    selectedRows.length > 1 ? false : true
                                }
                                variant="outlined"
                                label={"Enter Group Name"}
                                value={groupName}
                                size="small"
                                onChange={(e) => setGroupName(e.target.value)}
                            ></TextField> */}
                            <Button
                                variant="contained"
                                sx={{ marginLeft: "10px" }}
                                // disabled={
                                //     selectedRows.length > 1 ? false : true
                                // }
                                onClick={() => setEditOpen(true)}
                            >
                                Edit Group (numbers)
                            </Button>
                            <Button
                                variant="contained"
                                sx={{ marginLeft: "10px" }}
                                // disabled={
                                //     selectedRows.length > 1 ? false : true
                                // }
                                onClick={() => setOpen(true)}
                            >
                                Create Group
                            </Button>

                            <Tooltip
                                title="Delete groups or phone numbers"
                                arrow
                            >
                                <IconButton
                                    onClick={() => setDeletModalOpening(true)}
                                    sx={{
                                        backgroundColor: "primary.main",
                                        color: "white",

                                        marginLeft: 1,
                                        borderRadius: "4px",
                                        "&:hover": {
                                            backgroundColor: "primary.dark",
                                        },
                                    }}
                                >
                                    <DeleteOutline fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                    {/* <WarningMessage /> */}

                    {totalRows && (
                        <Typography sx={{ fontWeight: "700", mt: 2 }}>
                            Total Rows: {totalRows}{" "}
                        </Typography>
                    )}

                    <Paper sx={{ width: "100%", overflow: "hidden" }}>
                        <TableContainer sx={{ maxHeight: "calc(100vh - 300px)" ,overflowY: "auto", }}>
                            <Table
                                stickyHeader
                                component={Paper}
                                aria-label="sticky table"
                                sx={{
                                    minWidth: 650,
                                }}
                            >
                                <TableHead
                                    sx={{
                                        bgcolor: "#1a2333",
                                    }}
                                >
                                    <TableRow sx={{ bgcolor: "#1a2333" }}>
                                        <TableCell
                                            sx={{
                                                color: "#fcfdff",
                                                bgcolor: "#1a2333",
                                            }}
                                        >
                                            {/* <Checkbox
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                                sx={{ color: "#fcfdff" }}
                                            /> */}
                                            ID
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#fcfdff",
                                                bgcolor: "#1a2333",
                                            }}
                                        >
                                            PHONE NUMBER
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#fcfdff",
                                                bgcolor: "#1a2333",
                                            }}
                                        >
                                            ADDED ON
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                color: "#fcfdff",
                                                bgcolor: "#1a2333",
                                            }}
                                        >
                                            GROUP NAME
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.length === 0 && (
                                        <>
                                            <TableRow

                                            // sx={{
                                            //     "&:last-child td, &:last-child th": {
                                            //         border: 0,
                                            //     },
                                            // }}
                                            >
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                ></TableCell>
                                                {/* <TableCell></TableCell> */}

                                                <TableCell align="left">
                                                    NO DATA
                                                </TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </>
                                    )}
                                    {filteredData.length !== 0 &&
                                        filteredData.map((row, idx) => (
                                            <TableRow
                                                key={row.id}
                                                // sx={{
                                                //     "&:last-child td, &:last-child th": {
                                                //         border: 0,
                                                //     },
                                                // }}
                                            >
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {/* <Checkbox
                                                        checked={selectedRows.includes(
                                                            idx
                                                        )}
                                                        onChange={() =>
                                                            handleCheckboxChange(
                                                                idx
                                                            )
                                                        }
                                                    /> */}
                                                    {row.id}
                                                    {/* {idx +
                                                        1 +
                                                        100 * currentPage} */}
                                                </TableCell>

                                                <TableCell>
                                                    {row.phone_number}
                                                </TableCell>

                                                <TableCell>
                                                    {new Date(
                                                        row.created_at
                                                    ).toLocaleString()}
                                                </TableCell>

                                                <TableCell
                                                    align="left"
                                                    sx={
                                                        {
                                                            // bgcolor: "yellow",
                                                        }
                                                    }
                                                >
                                                    {row.group_name}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                {/* <TableFooter>
                            <TablePagination rowsPerPageOptions={[10, 50]} />
                        </TableFooter> */}
                            </Table>
                        </TableContainer>
                    </Paper>

                    <Box
                        sx={{
                            marginLeft: "auto",
                            width: "100%",
                            display: "flex",
                            justifyContent: "end",
                            mt: 2,
                        }}
                    >
                        {filteredData.length > 0 && (
                            <Pagination
                                count={totalPage}
                                color="primary"
                                page={currentPage || 1}
                                onChange={handlePageChange}
                            />
                        )}
                    </Box>
                </Box>
            )}

            <Box sx={{ display: "flex" }}></Box>
        </Box>
    );
};

export default GroupAdd;
